// This is provided so consumers can import `sku/@loadable/component`,
// since they don't depend on `@loadable/component` directly.
import loadable, { loadableReady } from '@loadable/component';

export default loadable;
export { loadableReady };
